// extracted by mini-css-extract-plugin
export var catIcon = "DishIcon-module--catIcon--jthhN";
export var iconWrapper = "DishIcon-module--iconWrapper--NpUmj";
export var imageWrapper = "DishIcon-module--imageWrapper--32wrC";